import React from 'react';
import Header from './Header';
import { GalleryLeft, GalleryRight } from 'components';
import { data } from './data';
import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <Header />
      <S.Content>
        <S.Text>
          <p className="drop-caps">
            Não faz muito tempo, algumas das maiores marcas nacionais tinham
            como principal modelo de negócio e de imagem as grandes grifes de
            fora do país, em especial as europeias. O objetivo era criar um
            produto dito de luxo, exclusivo, de difícil acesso, cifras altas e
            lucro a qualquer custo. Só que a moda muda, e não só esteticamente.{' '}
          </p>
          <p>
            Nos últimos anos, pudemos acompanhar o surgimento e – mais
            importante – o crescimento de uma nova geração de criadores e
            etiquetas com ideias, formas de trabalho e objetivos bastante
            diferentes daqueles vistos ao longo das duas décadas anteriores.
          </p>
          <p>
            Vender roupa, claro, continua como meta número um, pois é a base da
            coisa toda. Porém agora existem outros fatores na equação, como
            gerar impacto positivo ambiental e socialmente, contar histórias e
            preservar saberes e culturas regionais.
          </p>
        </S.Text>
      </S.Content>
      {data.map((item) =>
        item.type === 'left' ? (
          <GalleryLeft key={item.title} data={item} />
        ) : (
          <GalleryRight key={item.title} data={item} />
        )
      )}
    </S.Container>
  );
};

export default Main;
